import React from "react";
import PropTypes from "prop-types";
import { ColumnPropTypes } from "../../props";

import { v4 as uuidv4 } from "uuid";

import Tr from "./row/tr";
import Th from "./row/th";

function Thead({ columns }) {
  // let rows = [];
  let cols = [];

  let withPrefix = false;
  let withTitle = false;
  let withSuffix = false;

  for (let columnIndex in columns) {
    let column = columns[columnIndex];

    if (typeof column === "object") {
      if (!withPrefix) {
        if (column.prefix) {
          withPrefix = true;
        }
      }

      if (!withTitle) {
        if (column.title) {
          withTitle = true;
        }
      }

      if (!withSuffix) {
        if (column.suffix) {
          withSuffix = true;
        }
      }

      if (!column.hasOwnProperty("isRenderInBody") || !column.isRenderInBody) {
        cols.push(<Th column={column} i={columnIndex} key={uuidv4()} />);
      }
    }
  }

  let withClass = getWithClass(withPrefix, withTitle, withSuffix);

  if (cols.length) {
    return (
      <thead>
        <Tr className={withClass}>{cols}</Tr>
      </thead>
    );
  } else {
    return null;
  }
}

function getWithClass(withPrefix, withTitle, withSuffix) {
  let withClass = "";

  if (withTitle) {
    if (withPrefix) {
      if (withSuffix) {
        withClass = "with-prefix-title-suffix";
      } else {
        withClass = "with-prefix-title";
      }
    } else {
      withClass = "with-title";
    }
  } else {
    if (withPrefix) {
      if (withSuffix) {
        withClass = "with-prefix-suffix";
      } else {
        withClass = "with-prefix";
      }
    } else {
      if (withSuffix) {
        withClass = "with-suffix";
      }
    }
  }

  return withClass;
}

Thead.defaultProps = {
  columns: []
};

Thead.propTypes = {
  // Колонки
  columns: PropTypes.arrayOf(ColumnPropTypes)
};

export default Thead;
